import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { DashboardActions } from '../actions';


export const dashboardFeatureKey = 'admindashboard';

export interface State {
  transferCounter: any;
  transferCounterLoaded: boolean;
  transferCounterLoading: boolean;
  transferCounterLoadingFailure: boolean;

  fileCounter: any;
  fileCounterLoaded: boolean;
  fileCounterLoading: boolean;
  fileCounterLoadingFailure: boolean;

  sizeCounter: any;
  sizeCounterLoaded: boolean;
  sizeCounterLoading: boolean;
  sizeCounterLoadingFailure: boolean;

  totalActiveUsersCounter: any;
  totalActiveUsersCounterLoaded: boolean;
  totalActiveUsersCounterLoading: boolean;
  totalActiveUsersCounterLoadingFailure: boolean;

  activeUsersCounter: any;
  activeUsersCounterLoaded: boolean;
  activeUsersCounterLoading: boolean;
  activeUsersCounterLoadingFailure: boolean;

  activeGuestsCounter: any;
  activeGuestsCounterLoaded: boolean;
  activeGuestsCounterLoading: boolean;
  activeGuestsCounterLoadingFailure: boolean;

  transferCountSeries: any[];
  transferCountSeriesLoaded: boolean;
  transferCountSeriesLoading: boolean;
  transferCountSeriesLoadingFailure: boolean;

  sizeCountSeries: any[];
  sizeCountSeriesLoaded: boolean;
  sizeCountSeriesLoading: boolean;
  sizeCountSeriesLoadingFailure: boolean;

  fileCountSeries: any[];
  fileCountSeriesLoaded: boolean;
  fileCountSeriesLoading: boolean;
  fileCountSeriesLoadingFailure: boolean;

  activeUsersCountSeries: any[];
  activeUsersCountSeriesLoaded: boolean;
  activeUsersCountSeriesLoading: boolean;
  activeUsersCountSeriesLoadingFailure: boolean;

  activeGuestsCountSeries: any[];
  activeGuestsCountSeriesLoaded: boolean;
  activeGuestsCountSeriesLoading: boolean;
  activeGuestsCountSeriesLoadingFailure: boolean;

  totalActiveUsersCountSeries: any[];
  totalActiveUsersCountSeriesLoaded: boolean;
  totalActiveUsersCountSeriesLoading: boolean;
  totalActiveUsersCountSeriesLoadingFailure: boolean;
}

export const initialState: State = {
  transferCounter: null,
  transferCounterLoaded: false,
  transferCounterLoading: false,
  transferCounterLoadingFailure: null,

  fileCounter: null,
  fileCounterLoaded: false,
  fileCounterLoading: false,
  fileCounterLoadingFailure: null,

  sizeCounter: null,
  sizeCounterLoaded: false,
  sizeCounterLoading: false,
  sizeCounterLoadingFailure: null,

  totalActiveUsersCounter: null,
  totalActiveUsersCounterLoaded: false,
  totalActiveUsersCounterLoading: false,
  totalActiveUsersCounterLoadingFailure: null,

  activeUsersCounter: null,
  activeUsersCounterLoaded: false,
  activeUsersCounterLoading: false,
  activeUsersCounterLoadingFailure: null,
  
  activeGuestsCounter: null,
  activeGuestsCounterLoaded: false,
  activeGuestsCounterLoading: false,
  activeGuestsCounterLoadingFailure: null,

  transferCountSeries: [],
  transferCountSeriesLoaded: false,
  transferCountSeriesLoading: false,
  transferCountSeriesLoadingFailure: null,

  sizeCountSeries: [],
  sizeCountSeriesLoaded: false,
  sizeCountSeriesLoading: false,
  sizeCountSeriesLoadingFailure: null,

  fileCountSeries: [],
  fileCountSeriesLoaded: false,
  fileCountSeriesLoading: false,
  fileCountSeriesLoadingFailure: null,

  activeUsersCountSeries: [],
  activeUsersCountSeriesLoaded: false,
  activeUsersCountSeriesLoading: false,
  activeUsersCountSeriesLoadingFailure: null,

  activeGuestsCountSeries: [],
  activeGuestsCountSeriesLoaded: false,
  activeGuestsCountSeriesLoading: false,
  activeGuestsCountSeriesLoadingFailure: null,

  totalActiveUsersCountSeries: [],
  totalActiveUsersCountSeriesLoaded: false,
  totalActiveUsersCountSeriesLoading: false,
  totalActiveUsersCountSeriesLoadingFailure: null,
};

const dashboardReducer = createReducer(
  initialState,
  on(DashboardActions.loadAccountTransferCount, DashboardActions.loadTeamTransferCount, (state) => ({
    ...state,
    transferCountSeries: initialState.transferCountSeries,
    transferCountSeriesLoading: true,
    transferCountSeriesLoaded: initialState.transferCountSeriesLoaded,
    transferCountSeriesLoadingFailure: initialState.transferCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountTransferCountSuccess, DashboardActions.loadTeamTransferCountSuccess, (state, { transferCountSeries }) => ({
    ...state,
    transferCountSeries,
    transferCountSeriesLoading: false,
    transferCountSeriesLoaded: true,
    transferCountSeriesLoadingFailure: initialState.transferCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountTransferCountFailure, DashboardActions.loadTeamTransferCountFailure, (state, { error }) => ({
    ...state,
    transferCountsLoading: false,
    transferCountsLoadingFailure: true,
  })),
  on(DashboardActions.loadAccountSizeCount, DashboardActions.loadTeamSizeCount, (state) => ({
    ...state,
    sizeCountSeries: initialState.sizeCountSeries,
    sizeCountSeriesLoading: true,
    sizeCountSeriesLoaded: initialState.sizeCountSeriesLoaded,
    sizeCountSeriesLoadingFailure: initialState.sizeCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountSizeCountSuccess, DashboardActions.loadTeamSizeCountSuccess, (state, { sizeCountSeries }) => ({
    ...state,
    sizeCountSeries,
    sizeCountSeriesLoading: false,
    sizeCountSeriesLoaded: true,
    sizeCountSeriesLoadingFailure: initialState.sizeCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountSizeCountFailure, DashboardActions.loadTeamSizeCountFailure, (state, { error }) => ({
    ...state,
    sizeCountsLoading: false,
    sizeCountsLoadingFailure: true,
  })),
  on(DashboardActions.loadAccountFileCount, DashboardActions.loadTeamFileCount, (state) => ({
    ...state,
    fileCountSeries: initialState.fileCountSeries,
    fileCountSeriesLoading: true,
    fileCountSeriesLoaded: initialState.fileCountSeriesLoaded,
    fileCountSeriesLoadingFailure: initialState.fileCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountFileCountSuccess, DashboardActions.loadTeamFileCountSuccess, (state, { fileCountSeries }) => ({
    ...state,
    fileCountSeries,
    fileCountSeriesLoading: false,
    fileCountSeriesLoaded: true,
    fileCountSeriesLoadingFailure: initialState.fileCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountFileCountFailure, DashboardActions.loadTeamFileCountFailure, (state, { error }) => ({
    ...state,
    fileCountsLoading: false,
    fileCountsLoadingFailure: true,
  })),
  on(DashboardActions.loadAccountActiveUsersCount, DashboardActions.loadTeamActiveUsersCount, (state) => ({
    ...state,
    activeUsersCountSeries: initialState.activeUsersCountSeries,
    activeUsersCountSeriesLoading: true,
    activeUsersCountSeriesLoaded: initialState.activeUsersCountSeriesLoaded,
    activeUsersCountSeriesLoadingFailure: initialState.activeUsersCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountActiveUsersCountSuccess, DashboardActions.loadTeamActiveUsersCountSuccess, (state, { activeUsersCountSeries }) => ({
    ...state,
    activeUsersCountSeries,
    activeUsersCountSeriesLoading: false,
    activeUsersCountSeriesLoaded: true,
    activeUsersCountSeriesLoadingFailure: initialState.activeUsersCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountActiveUsersCountFailure, DashboardActions.loadTeamActiveUsersCountFailure, (state, { error }) => ({
    ...state,
    activeUsersCountSeriesLoading: false,
    activeUsersCountSeriesLoadingFailure: true,
  })),
  on(DashboardActions.loadAccountActiveGuestsCount, DashboardActions.loadTeamActiveGuestsCount, (state) => ({
    ...state,
    activeGuestsCountSeries: initialState.activeGuestsCountSeries,
    activeGuestsCountSeriesLoading: true,
    activeGuestsCountSeriesLoaded: initialState.activeGuestsCountSeriesLoaded,
    activeGuestsCountSeriesLoadingFailure: initialState.activeGuestsCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountActiveGuestsCountSuccess, DashboardActions.loadTeamActiveGuestsCountSuccess, (state, { activeGuestsCountSeries }) => ({
    ...state,
    activeGuestsCountSeries,
    activeGuestsCountSeriesLoading: false,
    activeGuestsCountSeriesLoaded: true,
    activeGuestsCountSeriesLoadingFailure: initialState.activeGuestsCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountActiveGuestsCountFailure, DashboardActions.loadTeamActiveGuestsCountFailure, (state, { error }) => ({
    ...state,
    activeGuestsCountSeriesLoading: false,
    activeGuestsCountSeriesLoadingFailure: true,
  })),
  on(DashboardActions.loadAccountTotalActiveUsersCount, DashboardActions.loadTeamTotalActiveUsersCount, (state) => ({
    ...state,
    totalActiveUsersCountSeries: initialState.totalActiveUsersCountSeries,
    totalActiveUsersCountSeriesLoading: true,
    totalActiveUsersCountSeriesLoaded: initialState.totalActiveUsersCountSeriesLoaded,
    totalActiveUsersCountSeriesLoadingFailure: initialState.totalActiveUsersCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountTotalActiveUsersCountSuccess, DashboardActions.loadTeamTotalActiveUsersCountSuccess, (state, { totalActiveUsersCountSeries }) => ({
    ...state,
    totalActiveUsersCountSeries,
    totalActiveUsersCountSeriesLoading: false,
    totalActiveUsersCountSeriesLoaded: true,
    totalActiveUsersCountSeriesLoadingFailure: initialState.totalActiveUsersCountSeriesLoadingFailure,
  })),
  on(DashboardActions.loadAccountTotalActiveUsersCountFailure, DashboardActions.loadTeamTotalActiveUsersCountFailure, (state, { error }) => ({
    ...state,
    totalActiveUsersCountSeriesLoading: false,
    totalActiveUsersCountSeriesLoadingFailure: true,
  })),
  // Daily counters
  on(DashboardActions.loadTransferCounter, (state) => ({
    ...state,
    transferCounter: initialState.transferCounter,
    transferCounterLoading: true,
    transferCounterLoaded: initialState.transferCounterLoaded,
    transferCounterLoadingFailure: initialState.transferCounterLoadingFailure,
  })),
  on(DashboardActions.loadTransferCounterSuccess, (state, { transferCounter }) => ({
    ...state,
    transferCounter,
    transferCounterLoading: false,
    transferCounterLoaded: true,
    transferCounterLoadingFailure: initialState.transferCounterLoadingFailure,
  })),
  on(DashboardActions.loadTransferCounterFailure, (state, { error }) => ({
    ...state,
    transferCounterLoading: false,
    transferCounterLoadingFailure: true,
  })),
  on(DashboardActions.loadFileCounter, (state) => ({
    ...state,
    fileCounter: initialState.fileCounter,
    fileCounterLoading: true,
    fileCounterLoaded: initialState.fileCounterLoaded,
    fileCounterLoadingFailure: initialState.fileCounterLoadingFailure,
  })),
  on(DashboardActions.loadFileCounterSuccess, (state, { fileCounter }) => ({
    ...state,
    fileCounter,
    fileCounterLoading: false,
    fileCounterLoaded: true,
    fileCounterLoadingFailure: initialState.fileCounterLoadingFailure,
  })),
  on(DashboardActions.loadFileCounterFailure, (state, { error }) => ({
    ...state,
    fileCounterLoading: false,
    fileCounterLoadingFailure: true,
  })),
  on(DashboardActions.loadSizeCounter, (state) => ({
    ...state,
    sizeCounter: initialState.sizeCounter,
    sizeCounterLoading: true,
    sizeCounterLoaded: initialState.sizeCounterLoaded,
    sizeCounterLoadingFailure: initialState.sizeCounterLoadingFailure,
  })),
  on(DashboardActions.loadSizeCounterSuccess, (state, { sizeCounter }) => ({
    ...state,
    sizeCounter,
    sizeCounterLoading: false,
    sizeCounterLoaded: true,
    sizeCounterLoadingFailure: initialState.sizeCounterLoadingFailure,
  })),
  on(DashboardActions.loadSizeCounterFailure, (state, { error }) => ({
    ...state,
    sizeCounterLoading: false,
    sizeCounterLoadingFailure: true,
  })),
  on(DashboardActions.loadTotalActiveUsersCounter, (state) => ({
    ...state,
    totalActiveUsersCounter: initialState.totalActiveUsersCounter,
    totalActiveUsersCounterLoading: true,
    totalActiveUsersCounterLoaded: initialState.totalActiveUsersCounterLoaded,
    totalActiveUsersCounterLoadingFailure: initialState.totalActiveUsersCounterLoadingFailure,
  })),
  on(DashboardActions.loadTotalActiveUsersCounterSuccess, (state, { totalActiveUsersCounter }) => ({
    ...state,
    totalActiveUsersCounter,
    totalActiveUsersCounterLoading: false,
    totalActiveUsersCounterLoaded: true,
    totalActiveUsersCounterLoadingFailure: initialState.totalActiveUsersCounterLoadingFailure,
  })),
  on(DashboardActions.loadTotalActiveUsersCounterFailure, (state, { error }) => ({
    ...state,
    totalActiveUsersCounterLoading: false,
    totalActiveUsersCounterLoadingFailure: true,
  })),
  on(DashboardActions.loadActiveUsersCounter, (state) => ({
    ...state,
    activeUsersCounter: initialState.activeUsersCounter,
    activeUsersCounterLoading: true,
    activeUsersCounterLoaded: initialState.activeUsersCounterLoaded,
    activeUsersCounterLoadingFailure: initialState.activeUsersCounterLoadingFailure,
  })),
  on(DashboardActions.loadActiveUsersCounterSuccess, (state, { activeUsersCounter }) => ({
    ...state,
    activeUsersCounter,
    activeUsersCounterLoading: false,
    activeUsersCounterLoaded: true,
    activeUsersCounterLoadingFailure: initialState.activeUsersCounterLoadingFailure,
  })),
  on(DashboardActions.loadActiveUsersCounterFailure, (state, { error }) => ({
    ...state,
    activeUsersCounterLoading: false,
    activeUsersCounterLoadingFailure: true,
  })),
  on(DashboardActions.loadActiveGuestsCounter, (state) => ({
    ...state,
    activeGuestsCounter: initialState.activeGuestsCounter,
    activeGuestsCounterLoading: true,
    activeGuestsCounterLoaded: initialState.activeGuestsCounterLoaded,
    activeGuestsCounterLoadingFailure: initialState.activeGuestsCounterLoadingFailure,
  })),
  on(DashboardActions.loadActiveGuestsCounterSuccess, (state, { activeGuestsCounter }) => ({
    ...state,
    activeGuestsCounter,
    activeGuestsCounterLoading: false,
    activeGuestsCounterLoaded: true,
    activeGuestsCounterLoadingFailure: initialState.activeGuestsCounterLoadingFailure,
  })),
  on(DashboardActions.loadActiveGuestsCounterFailure, (state, { error }) => ({
    ...state,
    activeGuestsCounterLoading: false,
    activeGuestsCounterLoadingFailure: true,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return dashboardReducer(state, action);
}

export const getDashboardState = createFeatureSelector<State>(dashboardFeatureKey);

export const getTransferCountSeries = createSelector(
  getDashboardState,
  (state: State) => state.transferCountSeries
);

export const getTransferCountSeriesLoading = createSelector(
  getDashboardState,
  (state: State) => state.transferCountSeriesLoading
);

export const getTransferCountSeriesLoaded = createSelector(
  getDashboardState,
  (state: State) => state.transferCountSeriesLoaded
);

export const getSizeCountSeries = createSelector(
  getDashboardState,
  (state: State) => state.sizeCountSeries
);

export const getSizeCountSeriesLoading = createSelector(
  getDashboardState,
  (state: State) => state.sizeCountSeriesLoading
);

export const getSizeCountSeriesLoaded = createSelector(
  getDashboardState,
  (state: State) => state.sizeCountSeriesLoaded
);

export const getFileCountSeries = createSelector(
  getDashboardState,
  (state: State) => state.transferCountSeries
);

export const getFileCountSeriesLoading = createSelector(
  getDashboardState,
  (state: State) => state.fileCountSeriesLoading
);

export const getFileCountSeriesLoaded = createSelector(
  getDashboardState,
  (state: State) => state.fileCountSeriesLoaded
);

